<template>
  <vs-popup class="product-order-create-popup"
            title="PRODUCT ORDER CREATE"
            @close="onClickClose"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card  no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="popup" @submit.prevent="handleSubmit(checkVamRecords)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-2/3 md:s-full w-full md:mb-0">
                  <vs-table id="create-product-order-table" :data="cartItems" stripe>
                    <template slot="header">
                      <h3>
                        <span class="text-danger text-lg mb-8">Available credit ({{ account_currency }}):  <b>{{creditDetails.available_credit | thousand_seperator}}</b></span>
                      </h3>
                    </template>
                    <template slot="thead">
                      <vs-th width="14%">PRODUCT CODE/NAME</vs-th>
                      <vs-th width="5%">PACK SIZE</vs-th>
                      <vs-th width="5%">INCOTERM</vs-th>
                      <vs-th width="18%">DATE</vs-th>
                      <vs-th width="6%">QUANTITY (KG)</vs-th>
                      <vs-th width="8%">UNIT PRICE (KG/{{ account_currency }})</vs-th>
                      <vs-th width="9%">TOTAL PRICE ({{account_currency}})</vs-th>
                      <vs-th width="3%">M&F ALERT</vs-th>
                      <vs-th width="17%" class="text-warning">STOCK ALERT</vs-th>
                      <vs-th width="15%">ACTIONS</vs-th>
                    </template>
                    
                    <template slot-scope="{data}">
                      <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                        <vs-td :data="data[indextr].formulation_code">
                          {{ data[indextr].formulation_code }} <br>
                          {{ data[indextr].formulation_name }}
                        </vs-td>

                        <vs-td :data="data[indextr].pack_size">
                          {{ data[indextr].pack_size }}
                        </vs-td>

                        <vs-td :data="data[indextr].incoterm">
                          {{ incotermsFactory(data[indextr].incoterm, indextr) }}
                        </vs-td>

                        <vs-td>
                          <div style="font-size: 10px; margin-bottom: 2px;">Required By</div>
                          <ValidationProvider :vid="indextr + 'required_by' " name="Required by date" :rules="{required: true, after_date: {
                            target: data[indextr].shipment_date,
                            targetName: 'shipment date'
                          }}" v-slot="{ errors }">
                            <vx-tooltip v-if="errors[0]" :text="errors[0]" position="top">
                              <flat-pickr :config="{minDate: new Date().fp_incr(0), dateFormat: 'd/m/Y'}" class="w-full"
                                          style="border-color: #ea5455 !important;"
                                          v-model="data[indextr].required_by" placeholder="Choose Date"/>
                            </vx-tooltip>
                            <flat-pickr v-else :config="{minDate: new Date().fp_incr(0), dateFormat: 'd/m/Y'}" class="w-full"
                                        v-model="data[indextr].required_by" placeholder="Choose Date"/>
                          </ValidationProvider>
                          <div style="font-size: 10px; margin-top: 6px; margin-bottom: 2px;">Ship By</div>
                          <ValidationProvider :vid="indextr + 'shipment_date' " :name="indextr + 'shipment_date'" rules="required" v-slot="{ errors }">
                            <vx-tooltip v-if="errors[0]" :text="errors[0]" position="top">
                              <flat-pickr :config="{dateFormat: 'd/m/Y'}" class="w-full"
                                          style="border-color: #ea5455 !important;"
                                          v-model="data[indextr].shipment_date" placeholder="Choose Date"/>
                            </vx-tooltip>
                            <flat-pickr v-else :config="{dateFormat: 'd/m/Y'}" class="w-full"
                                        v-model="data[indextr].shipment_date" placeholder="Choose Date"/>
                          </ValidationProvider>
                        </vs-td>

                        <vs-td :data="data[indextr].quantity">
                          <ValidationProvider :vid="indextr + 'quantity' " :name="indextr + 'quantity'" :rules="'moq:'+data[indextr].min_order_quantity" v-slot="{ errors }">
                            <vs-input
                              :disabled="['contract', 'bespoke'].includes(String(data[indextr].type || '').toLowerCase())"
                              v-on:input="onChangeQty(data[indextr], indextr)"  type="text"
                              v-model="data[indextr].quantity" class="w-full"
                              :name="'quantity'" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                          </ValidationProvider>
                        </vs-td>
                        <vs-td :data="data[indextr].unit_price">
                          {{ data[indextr].unit_price }}
                        </vs-td>

                        <vs-td :data="data[indextr].unit_price">
                          {{data[indextr].quantity ? (Number(data[indextr].unit_price) * data[indextr].quantity).toFixed(2) : '0.00'}}
                        </vs-td>

                        <vs-td>
                          <vx-tooltip v-if="!data[indextr].is_m_f_added"  class="mr-2" text="This item has default M&F applied to pricing" position="top">
                            <vs-button icon-pack="feather" icon="icon-alert-triangle" color="danger" size="small"></vs-button>
                          </vx-tooltip>
                        </vs-td>

                        <vs-td>
                          <div style="font-size: 11px; border-left: 3px solid rgba(255,159,67,0.6); padding-left: 7px; display: flex; flex-direction: column; gap: 6px;">
                            <div>
                              <div style="font-size: 10px;">Unallocated (KG)</div>
                              <div class="font-semibold text-warning" style="white-space: nowrap;">{{ data[indextr].available_unallocated_stock }}</div>
                            </div>
                            <div>
                              <div style="font-size: 10px;">Max Production (KG)</div>
                              <div class="font-semibold" :class="data[indextr].estimated_production_by_text_color" style="white-space: nowrap;">{{ data[indextr].max_production_possible }}</div>
                            </div>
                            <div>
                              <div style="font-size: 10px;">Est. By</div>
                              <div class="font-semibold flex items-center" :class="data[indextr].estimated_production_by_text_color" style="white-space: nowrap;">
                                <span class="mr-1">{{ data[indextr].estimated_production_by }}</span>
                                <vx-tooltip v-if="generateRMIssueTooltip(data[indextr].raw_material_stock_items) && data[indextr].estimated_production_by !== 'TODAY'"
                                  :text="generateRMIssueTooltip(data[indextr].raw_material_stock_items)" position="top">
                                  <vs-button icon-pack="feather" icon="icon-alert-triangle" color="danger" size="small"></vs-button>
                                </vx-tooltip>
                              </div>
                            </div>
                          </div>
                        </vs-td>

                        <vs-td :data="data[indextr].formulation_id">
                          <div class="vx-row">
                          <vx-tooltip class="mr-2" :text="`Remove ${tr.formulation_code} from cart`" position="top">
                            <vs-button @click.stop="onClickRemoveFromCart(data[indextr].id)"
                                       size="small" color="danger" type="border" icon-pack="feather" icon="icon-delete">Remove</vs-button>
                          </vx-tooltip>
<!--                            <vx-tooltip v-if="data[indextr].type === 'contract'" class="mr-2" text="Add/Update price tiers" position="top">-->
<!--                              <vs-button @click.stop="onClickCalculatePrice(data[indextr], indextr)"-->
<!--                                         size="small" color="primary" type="border" icon-pack="feather" icon="icon-plus">Price tiers</vs-button>-->
<!--                            </vx-tooltip>-->
                          </div>
                        </vs-td>

                      </vs-tr>
                      <vs-tr>
                        <vs-td style="font-weight: bolder">Total</vs-td>
                        <vs-td colspan="5"></vs-td>
                        <vs-td style="font-weight: bolder">{{totalCalculator()}}</vs-td>
                        <vs-td colspan="3"></vs-td>
                      </vs-tr>
                    </template>

                  </vs-table>
                  <h3 class="my-4" v-if="applicableRules.length">Additonal Cost ( {{ applicableRules.filter((x) => x.is_selected).length }} selected items )</h3>
                  <vs-table :data="applicableRules" v-if="applicableRules.length">
                    <template slot="thead">
                      <vs-th>NAME/DESCRIPTION</vs-th>
                      <vs-th width="10%">NOMINAL CODE</vs-th>
                      <vs-th width="15%">AMOUNT (Excl VAT) in {{ account_currency }}</vs-th>
                      <vs-th width="15%">TAX CODE</vs-th>
                      <vs-th width="15%">AMOUNT (Incl VAT) in {{ account_currency }}</vs-th>
                      <vs-th width="10%"></vs-th>
                    </template>

                    <template slot-scope="{data}">
                      <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                        <vs-td :data="data[indextr].name">
                          {{ data[indextr].name }}
                        </vs-td>

                        <vs-td>
                          {{ data[indextr].sage_nominal_code.code || "" }}
                        </vs-td>

                        <vs-td :data="data[indextr].amount">
                          <vs-input v-model="data[indextr].amount"></vs-input>
                        </vs-td>

                        <vs-td>
                          <vs-dropdown>

                            <a class="flex items-center">
                              {{ tr.vat_code || 'SELECT'}}
                              <i class="material-icons"> expand_more </i>
                            </a>

                            <vs-dropdown-menu style="z-index: 99999">

                              <vs-dropdown-item @click="onClickTaxCode(tax_code.code, tax_code.percent, indextr)" v-for="(tax_code, index) in tax_codes" :key="index">
                                <span>{{tax_code.code}} - {{tax_code.percent}} % </span>
                              </vs-dropdown-item>

                            </vs-dropdown-menu>
                          </vs-dropdown>
                        </vs-td>

                        <vs-td>
                          {{ Number(tr.amount * (1 + (Number(tr.vat_percent) / 100))).toFixed(2) }}
                        </vs-td>

                        <vs-td>
                          <vs-button @click.stop="tr.is_selected = !tr.is_selected" v-if="!tr.is_selected" size="small" icon-pack="feather" icon="icon-plus">Select</vs-button>
                          <vs-button @click.stop="tr.is_selected = !tr.is_selected" v-if="tr.is_selected" color="danger" size="small" icon-pack="feather" icon="icon-delete">Remove</vs-button>
                        </vs-td>
                      </vs-tr>
                    </template>

                    </vs-table>
            </div>

            

              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <vx-card>
                  <div class="vx-row mb-3">
                    <div class="vx-col md:w-full w-full md:mb-0">
                      <ValidationProvider vid="customers_order_number" name="customers_order_number" rules="" v-slot="{ errors }">
                        <small class="label">Customer Order Number</small>
                        <vs-input v-model="form.customers_order_number"  name="line1" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                      </ValidationProvider>
                    </div>
                  </div>
                <div class="vx-row mb-3" v-if="onClickAddressChange">
                  <div class="vx-col md:w-full w-full md:mb-0">
                    <ValidationProvider vid="formulation_items" name="formulation_items" rules="required" v-slot="{ errors }">
                      <small class="label">Select a delivery address</small>
                      <v-select
                        v-on:input="onChangeSelectDeliveryAddress"
                        name="formulation_items" placeholder=""
                        v-model="selectedAddress" :reduce="option => option"
                        label="country"
                        :options="addresses" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                        <template slot="option" slot-scope="option">
                          <div class="d-center">
                            <span style="font-weight: normal">{{ option.name }}</span> <span v-if="option.name">, </span>
                            <span style="font-weight: normal">{{ option.line1 }}</span> <span v-if="option.line1">, </span>
                            <span style="font-weight: normal">{{ option.line2 }}</span> <span v-if="option.line2">, </span>
                            <span style="font-weight: normal">{{ option.line3 }}</span> <span v-if="option.line3">, </span>
                            <span style="font-weight: normal">{{ option.town_state }}</span> <span v-if="option.town_state">, </span>
                            <span style="font-weight: normal">{{ option.post_code }}</span> <span v-if="option.post_code">, </span>
                            <span style="font-weight: normal">{{ option.country }}</span> <span v-if="option.country">, </span>
                          </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                          <div class="selected d-center">
                            <span style="font-weight: normal">{{ option.name }}</span> <span v-if="option.name">, </span>
                            <span style="font-weight: normal">{{ option.line1 }}</span> <span v-if="option.line1">, </span>
                            <span style="font-weight: normal">{{ option.line2 }}</span> <span v-if="option.line2">, </span>
                            <span style="font-weight: normal">{{ option.line3 }}</span> <span v-if="option.line3">, </span>
                            <span style="font-weight: normal">{{ option.town_state }}</span> <span v-if="option.town_state">, </span>
                            <span style="font-weight: normal">{{ option.post_code }}</span> <span v-if="option.post_code">, </span>
                            <span style="font-weight: normal">{{ option.country }}</span> <span v-if="option.country">, </span>
                          </div>
                        </template>
                      </v-select>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>

                  <div class="vx-row mb-3" v-if="onClickAddressChange">
                    <div class="vx-col md:w-full w-full md:mb-0">
                      <span style="cursor: pointer" class="float-right text-primary" @click="onClickNewAddressAdd">or add delivery address</span>
                    </div>
                  </div>

                <span v-if="!onClickAddressChange">
                  <div class="vx-row mb-3">
                    <div class="vx-col md:w-full w-full md:mb-0">
                      <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                        <small class="label">Name</small>
                        <vs-input v-model="form.name"  name="name" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="line1" name="line1" rules="required" v-slot="{ errors }">
                      <small class="label">Address Line 1</small>
                      <vs-input v-model="form.line1"  name="line1" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="line2" name="line2" rules="" v-slot="{ errors }">
                      <small class="label">Address Line 2</small>
                      <vs-input v-model="form.line2"  name="line2" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                </div>

                  <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="line3" name="line3" rules="" v-slot="{ errors }">
                      <small class="label">Address Line 3</small>
                      <vs-input v-model="form.line3"  name="line3" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="town_state" name="town_state" rules="required" v-slot="{ errors }">
                      <small class="label">Town / State</small>
                      <vs-input v-model="form.town_state"  name="town_state" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                </div>

                  <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="post_code" name="post_code" rules="required" v-slot="{ errors }">
                      <small class="label">Postal Code</small>
                      <vs-input v-model="form.post_code"  name="post_code" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="country" name="country" rules="required" v-slot="{ errors }">
                      <small class="label">Country</small>
                      <v-select :filter-by="myFilter" :clearable="false" name="country" placeholder=""
                                label="name" v-model="form.country" :reduce="option => option.name"
                                :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                  <div class="vx-row mb-3">
                      <div class="vx-col md:w-full w-full md:mb-0">
                        <span style="cursor: pointer" class="float-right text-primary" @click="onClickAddressChange = true">change delivery address</span>
                      </div>
                  </div>
                </span>

                  <!-- <div class="vx-row mb-3">
                    <div class="vx-col md:w-full md:mb-0">
                        <small class="label">Do you have a special delivery request date?</small>
                        <vs-switch v-model="is_special_request_date" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                          <span slot="on">Yes</span>
                          <span slot="off">No</span>
                        </vs-switch>
                    </div>
                  </div> -->
                  <!-- <div class="vx-row mb-3" v-if="is_special_request_date">
                    <div class="vx-col md:w-full w-full md:mb-0">
                      <ValidationProvider vid="start_timestamp" name="start_timestamp" rules="required" v-slot="{ errors }">
                        <small class="label">Required date</small>
                        <flat-pickr
                          :config="{minDate: 'today', dateFormat: 'd/m/Y'}"
                          class="hidden"
                          v-model="special_request_date"
                          placeholder="Choose Date"/>

                        <flat-pickr :config="{minDate: new Date().fp_incr(0), dateFormat: 'd/m/Y'}" class="w-full"
                                    v-model="special_request_date" placeholder="Choose Date"/>
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </div> -->

                <div class="vx-row mb-3">
                  <div class="vx-col md:w-full w-full md:mb-0">
                    <ValidationProvider vid="ukims" name="ukims" :rules="form.country === 'Northern Ireland' ? 'required' : ''" v-slot="{ errors }">
                      <small class="label">UKIMS Number</small>
                      <vs-input v-model="form.ukims"  name="ukims" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="vx-row mb-3 mt-8">
                  <div class="vx-col w-full">
                    <ValidationProvider vid="delivery_instruction" name="delivery_instruction" rules="" v-slot="{ errors }">
                      <small class="label">Delivery Instructions</small>
                      <vs-textarea class="mb-0" v-model="form.delivery_instruction" height="150px" />
                      <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="vx-row mb-3 mt-8">
                  <div class="vx-col w-full">
                    <ValidationProvider vid="note" name="note" rules="" v-slot="{ errors }">
                      <small class="label">Notes (private)</small>
                      <vs-textarea class="mb-0" v-model="form.note" height="150px" />
                      <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                </vx-card>
              </div>
          </div>
          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button :disabled="on_submit" button="submit" class="ml-auto mt-2">Order</vs-button>
            <vs-button @click="open =false" class="ml-4 mt-2" type="border" color="warning">Cancel</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
    <create-customer-account-limit-request-pop-up v-bind:account_currency="account_currency" ref="createCustomerAccountLimitRequestPopUp" />
    <customer-credit-check-pop-up v-on:openCreditLimitRequest="openCreditLimitRequest" v-on:refreshData="onlyRefreshData" v-on:onlyRefreshData="onlyRefreshData" ref="customerCreditCheckPopUp"/>
    <calculate-product-price-pop-up ref="calculateProductPricePopUp" v-bind:account_currency="account_currency"/>

    <vs-popup title="ENTER REASON CODE FOR SHORT ORDER"
      @close="activeShortOrderPopup = false"
      :active.sync="activeShortOrderPopup"
      :buttons-hidden="true" class="vam-update-popup">
        <div class="vx-row mb-4 font-bold">
          <div class="vx-col w-1/3">
            PRODUCT NAME/CODE
          </div>
          <div class="vx-col w-2/3">
            VAM REASON CODE
          </div>
        </div>
        <div class="vx-row mb-3" v-for="(item, index) in cartItems" :key="item.id">
          <div class="vx-col w-1/3" v-if="item.short_lead_time">
            <div class="mt-0" >{{ item.formulation_code || '' }} <br> {{ item.formulation_name || '' }}</div>
          </div>
          <div class="vx-col w-2/3" v-if="item.short_lead_time">
            <v-select :clearable="true" placeholder="" v-model="item.vam_type" :appendToBody="false"
              :options="vam_reason_codes" label="name" :reduce="option => option.name"
              :dir="$vs.rtl ? 'rtl' : 'ltr'" class="" multiple></v-select>
          </div>
        </div>
        <div class="flex flex-wrap items-center justify-end mt-8 popup-footer">
          <vs-button :disabled="on_submit" @click.stop="onClickCreateProductOrderConfirm()" button="submit" class="ml-auto mt-auto mb-0">Create Order</vs-button>
        </div>
    </vs-popup>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const CustomerRepository = RepositoryFactory.get('customer')
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture');
  const FormulationsRepository = RepositoryFactory.get('formulations');
  const AdditionalCostRepository = RepositoryFactory.get('additional_cost');
  const TaxRepository = RepositoryFactory.get('tax')
  const SettingsRepository = RepositoryFactory.get('settings');
  const CrmRepository = RepositoryFactory.get('crm');

  import CustomerCreditCheckPopUp from '@/components/popups/customer/product-orders/CustomerCreditCheckPopUp'
  import CreateCustomerAccountLimitRequestPopUp from '@/components/popups/customer/account-limit-request/CreateCustomerAccountLimitRequestPopUp'
  import CalculateProductPricePopUp from "@/components/popups/customer/product-orders/CalculateProductPricePopUp";
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import Calculations from '@/mixins/Calculations'
  import SageFactory from "@/mixins/SageFactory";

  import moment from "moment";


  function initialState() {
    return {
      open: false,
      id: '',
      form: {
        line1: '',
        line2: '',
        line3: '',
        town_state: '',
        post_code: '',
        country: '',
        ukims: '',
        delivery_instruction: '',
        formulation_items: [],
        add_costs: []
      },
      countryCodes: [],
      customers: [],
      formulations: [],
      addresses: [],
      selectedAddress: '',
      cartItems: [],
      productCatalogues: [],
      onClickAddressChange: true,
      is_uk_based_customer: false,
      is_special_request_date: false,
      special_request_date: null,
      customer_data: {},
      additional_cost_rules: [],
      applicableRules: [],
      tax_codes: [],
      fx_rate: 1,
      activeShortOrderPopup: false,
      vam_reason_codes: [],
      stock_data: [],
      on_submit: false,
      creating_order: false
    }
  }

export default {
  name: 'CreateCustomerSampleOrderPopUp',
  data () {
    return initialState()
  },
  props: {
    account_currency  : {type: String,  default: ''},
    creditDetails  : {type: Object,  default: () => ({})},
    customer_po : { type: String, default: '' },
    sales_quote_id: {
      type: String,
      default: ''
    },
    create_from_sales_quote: {
      type: Boolean,
      default: false
    },
  },
  methods:{
    async openPopup (id, is_uk_based_customer) {
      try {
        Object.assign(this.$data, initialState())
        this.id = id
        this.is_uk_based_customer = is_uk_based_customer
        this.form.customers_order_number = this.customer_po
        this.open = true;
        await this.$vs.loading({
          container: '#create-product-order-table',
          scale: 0.45
        })
        await this.fetchTaxCodes()
        await this.fetchAddtionalCostRules()
        await this.getCountryCodes()
        await this.getAddresses()
        await this.getItemsInItemsCart()
        await this.getCustomerDetails()
        await this.checkRules(this.cartItems, this.additional_cost_rules)
        this.$vs.loading.close('#create-product-order-table > .con-vs-loading')
        // this.getFormulations()

      } catch (error) {
        this.convertAndNotifyError(error)
      }
    },
    async refreshData() {
      this.open =false
    },
    async onlyRefreshData() {
      await this.getItemsInItemsCart()
    },
    async onClickCalculatePrice(data, index = null) {
      await this.$refs.calculateProductPricePopUp.openPopup(data, index)
    },
    async openCreditLimitRequest() {
      await this.onlyRefreshData()
      await this.$refs.createCustomerAccountLimitRequestPopUp.openPopup(this.id)
    },
    async onClickClose() {
      const vue = this;
      this.open = false
      await vue.$parent.onlyRefreshData()
    },
    async checkVamRecords() {
      if (this.on_submit) return
      this.on_submit = true
      try {
        let lead_time = 15
        const country = this.form.country

        const region = country === 'Great Britain'
          ? 'product_delivery_days_uk'
          : this.countryCodes.find(x => x.name === country && x.is_europe)
            ? 'product_delivery_days_eu'
            : 'product_delivery_days_row'

        lead_time = (await SettingsRepository.getTheItem(region)).data.data[region]
        lead_time = Number(lead_time)

        this.cartItems = this.cartItems.map(item => {
          const itemLeadTime = lead_time + (item.extra_lead_time || 0)

          // earliest required_by that passes = today + itemLeadTime working days (excluding weekends)
          const passMoment = moment()
          let addedWorkingDays = 0
          while (addedWorkingDays < itemLeadTime) {
            passMoment.add(1, "day")
            if (passMoment.day() !== 0 && passMoment.day() !== 6) {
              addedWorkingDays++
            }
          }
          const requiredByMoment = moment(item.required_by, "DD/MM/YYYY")
          const isShort = requiredByMoment.isBefore(passMoment, "day")

          return {
            ...item,
            short_lead_time: isShort
          }
        })
        const hasShortLeadTime = this.cartItems.some(item => item.short_lead_time)
        if(hasShortLeadTime) {
          await this.fetchVamReasonCodeList()
          this.activeShortOrderPopup = true
          this.on_submit = false
          return
        }
        await this.onClickCreateProductOrderConfirm()
      } catch (error) {
        this.on_submit = false
        this.convertAndNotifyError(error)
      }
    },
    async onClickCreateProductOrder () {
      if (this.creating_order) return
      this.creating_order = true
      this.on_submit = true
      const vue = this;
      this.activeShortOrderPopup = false
      await this.$vs.loading({
        container: '#create-product-order-table',
        scale: 0.45
      })
      let order_data = {}
       try {
         this.form.customer_id = this.id
         this.form.formulation_items = this.cartItems.map((m) => {
           return { id: m.formulation_id, quantity: m.quantity, price: (Number(m.unit_price)).toFixed(2), type: (m.type === 'List' || m.type === 'price') ? 'price' : 'contract', incoterm: m.incoterm, pack_size: Number(m.pack_size).toFixed(3), required_by: m.required_by, shipment_date: m.shipment_date, vam_type: m.vam_type || [] }
         })
        //  this.form.required_by = this.special_request_date
        if(this.applicableRules.length) {
          this.form.add_costs = this.applicableRules.filter((x) => x.is_selected).map((x) => {
            return { name: x.name, amount: Number(x.amount).toFixed(2), vat_percent: Number(x.vat_percent).toFixed(2), sage_nominal_code_id: x.sage_nominal_code_id }
          })
        }
        if(this.create_from_sales_quote) {
          this.form.sale_quote_id = Number(this.sales_quote_id)
        }
         order_data = (await CustomerRepository.createCustomerProductOrder(this.form)).data.data
         this.showSuccessMessage('Product order created successfully')
         this.open = false;
         await vue.$parent.refreshData()
       }catch (e) {
         this.convertAndNotifyError(e)
       } finally {
         this.creating_order = false
         this.on_submit = false
       }
      this.$vs.loading.close('#create-product-order-table > .con-vs-loading')
      if(this.$can('create-edit-sage-sale-order')) {
        await this.createSageSalesOrder(order_data, this.customer_data.sage_id)
      }
    },
    async getFormulations() {
      this.$vs.loading()
      const {data} = await FormulationsRepository.get(1, '', 50, '')
      this.formulations =  data.data
      this.$vs.loading.close()
    },
    async getCountryCodes() {
      this.countryCodes = (await SupplierManufactureRepository.getCountryCodes()).data.data;
    },
    async getCustomerDetails() {
      const {data }  =  (await CustomerRepository.getCustomerDetails(this.id)).data
      this.customer_data = data
      this.form.ukims = data.ukims || ""
    },
    async getAddresses() {
      this.addresses = (await CustomerRepository.getCustomerProductDeliveryAddresses(this.id)).data.data;
    },
    myFilter: (option, label, search) => {
      let temp = search.toLowerCase();
      return option.name.toLowerCase().indexOf(temp) > -1 ||
        option.isd_code.toLowerCase().indexOf(temp) > -1
    },
    doCheckItems(data) {

    },
    async getItemsInItemsCart() {
      try {
        const { data } = (await CustomerRepository.getItemsInProductCart(this.id)).data
        this.cartItems = data
        this.productCatalogues = (await CustomerRepository.getListOfCartProductCatalogue(
          { customer_id: this.id, formulation_ids: this.cartItems.map((x) => x.formulation_id) }
        )).data.data

        if(this.productCatalogues.length) {
          this.fx_rate = this.productCatalogues[0].fx_rate
        }

        this.cartItems = this.cartItems.map((n) => {
          const find =  this.productCatalogues.find((m) => m.id === n.formulation_id)
          n.min_order_quantity = find.min_order_quantity
          n.incoterm = n.incoterm
          n.pack_size = Number(n.pack_size).toFixed(3)
          n.unit_price = n.price
          n.price = find.price
          n.pe_g = find.pe_g
          n.is_m_f_added = find.is_m_f_added
          n.required_by = ''
          n.shipment_date = ''
          n.formulation_type = find.formulation_type || ''
          n.extra_lead_time = find.extra_lead_time || 0
          if (find && find.type) {
            n.type = find.type === 'List' ? 'price' : 'contract'
          }
          return n
        })
        await this.getDemandStockData()
      }catch (e) {
        this.convertAndNotifyError(e)
      }

    },
    async onClickRemoveFromCart(id) {
      await this.$vs.loading({
        container: '#create-product-order-table',
        scale: 0.45
      })
      try {
        await CustomerRepository.removeFormulationsFromProductCart(id)
        await this.getItemsInItemsCart()
        this.showSuccessMessage('Removed from cart!')
      }catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-product-order-table > .con-vs-loading')
    },
    async onClickUpdateFromCart(data) {
      await this.$vs.loading({
        container: '#popup',
        scale: 0.45
      })
      try {
        const payload = {quantity: data.quantity, price: data.unit_price, incoterm: data.incoterm, pack_size: data.pack_size}
        await CustomerRepository.updateFormulationsQuantityInProductCart(data.id, payload)
        await this.getItemsInItemsCart()
        this.showSuccessMessage('Product item quantity updated')
      }catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#popup > .con-vs-loading')
    },
    onChangeSelectDeliveryAddress(selected) {
      this.form.name = selected.name
      this.form.line1 = selected.line1
      this.form.line2 = selected.line2
      this.form.line3 = selected.line3
      this.form.town_state = selected.town_state
      this.form.post_code = selected.post_code
      this.form.country = selected.country

      this.form.delivery_instruction = selected.additional_info
      this.form.note = selected.notes ? selected.notes : ''
      this.onClickAddressChange = false
    },
    totalCalculator() {
      let total = 0;
      this.cartItems.forEach((m) => {
        if (!!m.unit_price) {
          total = total + Number(m.unit_price) * Number(m.quantity)
        }

      })
      return total.toFixed(2)
    },
    async onChangeQty(data, index) {
      if (['contract', 'bespoke'].includes(String(data.type || '').toLowerCase())) {
        return
      }
      this.cartItems[index].unit_price =  this.calculateProductListPrice(data.pe_g, data.quantity, data.fx_rate)
      if (Number(data.quantity) >= Number(data.min_order_quantity)) {
        this.updateCart(data, this)
      }
    },
    updateCart: _.debounce( async (data, vm) => {

      if (!vm.isCanAddOrderWithCredit()) {
        await vm.openCreditCheckPopUp()
        return null
      }

      await vm.onClickUpdateFromCart(data)
    }, 500),
    isCanAddOrderWithCredit() {
      if(this.creditDetails.account_type === 'proforma') {
        return true
      }
      const cart_total = this.totalCalculator()
      const available_credit = this.creditDetails.available_credit
      return Number(cart_total) < Number(available_credit)
    },
    async openCreditCheckPopUp() {
      await this.$refs.customerCreditCheckPopUp.openPopup(this.customerId)
    },
    incotermsFactory(incoterm, index) {
      return incoterm
      // if(!!incoterm) {
      //   this.cartItems[index].incoterm = incoterm
      //   return incoterm
      // } else if (this.is_uk_based_customer) {
      //   this.cartItems[index].incoterm = 'DDP'
      //   return 'DDP'
      // } else {
      //   this.cartItems[index].incoterm = 'EXW'
      //   return 'EXW'
      // }
    },
    onClickNewAddressAdd() {
      this.form.name = ""
      this.form.line1 = ""
      this.form.line2 = ""
      this.form.line3 = ""
      this.form.town_state = ""
      this.form.post_code = ""
      this.form.country = ""
      this.onClickAddressChange = false
    },
    async fetchAddtionalCostRules() {
      const { data } = await AdditionalCostRepository.getAdditionalCostList(1, '', 50, '')
      this.additional_cost_rules = data.data
    },
    checkRules(cartItems, rules) {
      const applicableRules = [];

      cartItems.forEach(item => {
          rules.forEach(rule => {
              if (rule.product_types.includes(item.formulation_type)) {
                  const itemQuantity = parseFloat(item.quantity);
                  const ruleQuantity = parseFloat(rule.quantity);
                  
                  let conditionMet = false;
                  switch (rule.condition) {
                      case "gte":
                          conditionMet = itemQuantity >= ruleQuantity;
                          break;
                      case "gt":
                          conditionMet = itemQuantity > ruleQuantity;
                          break;
                      case "lte":
                          conditionMet = itemQuantity <= ruleQuantity;
                          break;
                      case "lt":
                          conditionMet = itemQuantity < ruleQuantity;
                          break;
                      case "eq":
                          conditionMet = itemQuantity === ruleQuantity;
                          break;
                  }
                  if (conditionMet) {
                    const find_currency_price = rule.currencies.find((x) => x.currency === this.account_currency)
                      applicableRules.push({
                          name: rule.name,
                          amount: parseFloat(find_currency_price ? find_currency_price.amount : 0).toFixed(2),
                          vat_percent: "0.00",
                          vat_code: 'Z',
                          is_selected: true,
                          sage_nominal_code_id: rule.sage_nominal_code_id,
                          sage_nominal_code: rule.sage_nominal_code
                      });
                  }
              }
          });
      });
      this.applicableRules = applicableRules
      // return applicableRules;
    },
    async fetchTaxCodes() {
      try {
        const { data } =  await TaxRepository.getListOfTaxCodes(1, '', 150)
        this.tax_codes = data.data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    onClickTaxCode(code, percentage, indextr) {
      this.applicableRules[indextr].vat_code = code
      this.applicableRules[indextr].vat_percent = percentage
    },
    async onClickCreateProductOrderConfirm() {
      try {
        this.on_submit = true
        const atRiskProducts = this.cartItems
          .filter(item => {
            if (!/^\d{4}-\d{2}-\d{2}$/.test(item.estimated_production_by)) return false
            const requiredBy = moment(item.required_by, 'DD/MM/YYYY')
            const estimatedBy = moment(item.estimated_production_by, 'YYYY-MM-DD')
            return requiredBy.isBefore(estimatedBy)
          })
          .map(item => `${item.formulation_name}(${item.formulation_code})`)

        if (atRiskProducts.length > 0) {
          this.$vs.dialog({
            type: 'confirm', color: 'warning',
            title: 'Required by date at risk',
            text: `Your required by date is currently at risk with product${atRiskProducts.length > 1 ? 's' : ''} ${atRiskProducts.join(', ')}. Would you like to proceed?`,
            accept: async () => { await this.onClickCreateProductOrder() },
            cancel: () => { this.on_submit = false },
            acceptText: 'Yes, proceed', cancelText: 'No, go back'
          })
        } else {
          await this.onClickCreateProductOrder()
        }
      } catch (error) {
        this.on_submit = false
        this.convertAndNotifyError(error)
      }
    },
    async getDemandStockData() {
      try {
        const { data } = (await CustomerRepository.getDemandStockData({
          formulations: this.cartItems.map(x => ({ id: x.formulation_id, quantity_needed: Number(x.quantity).toFixed(3) }))
        })).data
       
        this.stock_data = data
        this.cartItems = this.cartItems.map(n => {
          const find = this.stock_data.find(m => m.id === n.formulation_id)
            n.available_unallocated_stock = find ? Number(find.available_unallocated_stock).toFixed(1) : 0
            n.max_production_possible = find ? Number(find.max_production_possible).toFixed(1) : 0
            n.raw_material_stock_items = find ? find.raw_material_stock_items || [] : []
         
          if (Number(n.quantity) > Number(n.max_production_possible)) {
          
            n.estimated_production_by = (find.product_availability_date) || '-'
            n.estimated_production_by_text_color = 'text-warning'
          } else {
            n.estimated_production_by = 'TODAY'
            n.estimated_production_by_text_color = 'text-success'
          }
          return n
        })
      } catch (error) {}
    },
    generateRMIssueTooltip(raw_material_stock_items = []) {
      const issues = raw_material_stock_items
        .filter(item => parseFloat(item.stock) < parseFloat(item.quantity_needed) ||
          (parseInt(item.estimated_delivery_days.min_days) === 0 && parseInt(item.estimated_delivery_days.max_days) === 0))
        .map(item => {
          const notes = []
          if (parseFloat(item.stock) < parseFloat(item.quantity_needed)) notes.push('low stock')
          if (parseInt(item.estimated_delivery_days.min_days) === 0 && parseInt(item.estimated_delivery_days.max_days) === 0) notes.push('missing delivery days in commercial tab')
          return `${item.code} — ${notes.join(' & ')}`
        })
      return issues.length ? 'Attention needed:<br>' + issues.join(`<br>`) : null
    },
    async fetchVamReasonCodeList() {
        try {
          const { data } = (await CrmRepository.getListVamType()).data
          this.vam_reason_codes = data
        } catch (error) {

        }
    }
  },
  computed: {

  },
  components: {
    'v-select': vSelect,
    flatPickr,
    CustomerCreditCheckPopUp,
    CreateCustomerAccountLimitRequestPopUp,
    CalculateProductPricePopUp
  },
  mixins: [SuccessMessage, ErrorMessages, Calculations, SageFactory],
}
</script>

<style scoped>
  .product-order-create-popup >>> .vs-popup {
    /*min-height: 80% !important;*/
    min-width: 90% !important;
  }
  .loader {
    text-align: center;
    color: #bbbbbb;
  }

  .vam-update-popup >>> .vs-popup {
    min-width: 50% !important;
    min-height: 30% !important;
  }
  .popup-footer {
    margin-top: auto;
    padding-top: 16px;
    display: flex;
    justify-content: flex-end;
  }

</style>
